import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Input,
} from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useRef, useState } from 'react'
import { RiCamera2Line } from 'react-icons/ri'
import { api, baseURL } from '../../../services/api'

const schema = yup.object().shape({
  innovation: yup.string().required('Campo obrigatório'),
})

export function EntregaMotorista() {
  const { register, handleSubmit, formState, watch, setError } = useForm({
    resolver: yupResolver(schema),
  })
  const [loading, setLoading] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [capturedImage, setCapturedImage] = useState(null)
  const canvasRef = useRef(null)
  const videoRef = useRef(null)

  const pedido = watch('innovation')

  const constraints = {
    video: {
      facingMode: { exact: 'environment' }, // "environment" para câmera traseira
      //melhorar a qualidade da imagem
      width: { min: 1280, ideal: 1920, max: 2560 },
      height: { min: 720, ideal: 1080, max: 1440 }
    },
  }

  const applyImageFilters = (context) => {
    // Aplicar filtro de suavização (redução de ruído)
    context.filter = 'blur(1px)';
  
    // Aumentar o contraste
    context.filter += ' contrast(130%)';
  
    // Aumentar a nitidez
    context.filter += ' brightness(110%)';
  };
  

  const openCamera = async (data) => {
    const { innovation } = data


    try {
      const response = await api.get(
        `/site/v2/crm-controle/valida-saida-entrega/${innovation}`
      )

      setIsModalOpen(true)
    } catch (error) {
      console.error('Error validating innovation:', error)
      alert(`${error.response.data}`)
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints)
      videoRef.current.srcObject = stream
    } catch (error) {
      console.error('Error accessing camera:', error)
    }
  }

  function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: mimeString })
  }

  const captureImage = async () => {
    const video = videoRef.current
    const canvas = canvasRef.current
    const context = canvas.getContext('2d')

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
  
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    applyImageFilters(context);

    const image = canvas.toDataURL('image/png')

    setCapturedImage(image)
    setIsModalOpen(false)
  }

  const sendImageToBackend = async () => {
    setLoading(true)
    const blob = dataURItoBlob(capturedImage)
    const file = new File([blob], 'captured_image.png', { type: 'image/png' })

    const formData = new FormData()
    formData.append('imagem', file)
    formData.append('pedido', pedido)

    try {
      const response = await baseURL.post(
        '/crm-controle/envia-imagem-entrega',
        formData
      )
      console.log('Response from API:', response.data)

      alert('Imagem enviada com sucesso!')
    } catch (error) {
      console.error('Error uploading image:', error)
      alert(`Erro ao enviar imagem: ${error.message}`)
      setLoading(false)
    }

    setLoading(false)

    setCapturedImage(null)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <HeadingPages name="Entrega motorista" bgColor="gray.800" />
      <Box maxW="1200px" mx="auto" px={2} w="100%">
        <Box
          p={2}
          marginTop="1rem"
          as="form"
          onSubmit={handleSubmit(openCamera)}
        >
          <Flex
            alignItems="start"
            justifyContent="center"
            gap={2}
            maxW="500px"
            mx="auto"
            w="100%"
          >
            <FormControl isInvalid={formState.errors.innovation}>
              <Input
                label="Número Innovation"
                type="number"
                {...register('innovation')}
                fontSize="1.3rem"
                size="lg"
                w="100%"
              />
              {!formState.errors.innovation && (
                <FormHelperText fontSize="1.3rem">
                  Por favor, digite o número da NFE.
                </FormHelperText>
              )}

              {formState.errors.innovation && (
                <FormErrorMessage
                  color="red.500"
                  fontWeight="bold"
                  fontSize="sm"
                  mt={1}
                >
                  {formState.errors.innovation?.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <Button
              colorScheme="blue"
              type="submit"
              size="lg"
              fontSize="1.3rem"
            >
              Buscar
            </Button>
          </Flex>

          {capturedImage && (
            <Flex
              flexDir="column"
              alignItems="center"
              justifyContent="center"
              gap={4}
              w="100%"
            >
              <Image
                src={capturedImage}
                alt="Captured"
                margin="1rem auto"
              />

              <Button
                colorScheme="blue"
                type="button"
                onClick={sendImageToBackend}
                ml={2}
                isLoading={loading}
              >
                Enviar foto
              </Button>
            </Flex>
          )}

          <Modal isOpen={isModalOpen} onClose={closeModal}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Câmera</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <video ref={videoRef} autoPlay playsInline />
                <canvas ref={canvasRef} style={{ display: 'none' }} />
                <Button
                  onClick={captureImage}
                  colorScheme="blue"
                  mt={2}
                  display="block"
                  margin="1rem auto"
                  isLoading={loading}
                >
                  <RiCamera2Line size={24} />
                </Button>
              </ModalBody>
            </ModalContent>
          </Modal>
        </Box>
      </Box>
    </>
  )
}
